<template>
  <div class="friendReceive">
    <!-- <common-title titleName="亲友专享优惠" :bcColor="'#F7F8FC'" :isAPPShow="true"></common-title> -->
    <div class="info">
      <div class="friend_phone">
        <span>当前好友:</span>
        {{ agentInfo.phone }}
      </div>
      <div class="img_box">
        <img class="img" :src="basicInfo.relativeImg" alt />
      </div>
    </div>
    <div class="botton">
      <div class="bottom_btn" @click="onReceive">立即领取</div>
    </div>
  </div>
</template>

<script>
import { reqInvitationInfo, reqReceive, reqAgentAccount } from '@/api/invitationCommission';
import wx from 'weixin-js-sdk';
import { mapState } from 'vuex';
import { setTokenFromCookie } from '@/utils/tools';

export default {
  components: {},
  data() {
    return {
      agentId: this.$route.query?.id || '',
      basicInfo: {},
      agentInfo: {},
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  mounted() {
    console.log(this.$route.query, 'query');
    if (!this.$root.$data.miniprogram) {
      console.log('zhixing huiqv l ');
      this.$router.replace('/invitation/friendTransfer');
      return;
    }
    this.getInvitationInfo();
    this.getAgentAccount();
  },
  methods: {
    // 查看活动基本信息
    getInvitationInfo() {
      reqInvitationInfo().then(res => {
        this.basicInfo = res;
      });
    },
    // 查看代理账户信息  agentId
    getAgentAccount() {
      reqAgentAccount(this.agentId).then(res => {
        this.agentInfo = res;
      });
    },
    async onReceive() {
      const subParams = {
        agentId: this.agentId,
        terminalMark: 8,
      };
      const { miniprogram = false } = this.$root.$data;
      console.log(this.userInfo.id, miniprogram, 'chao');
      this.$toast.loading();
      this.$root.getUserInfo().then(() => {
        console.log('11111111111111111111111');
        if (!this.userInfo.id) {
          this.$toast.clear();
          if (miniprogram) {
            let url = window.location.href;
            const [domain, searchParams] = url.split('?');
            console.log(domain, searchParams, 'ba');
            if (searchParams) {
              const params = searchParams.split('&');
              if (params) {
                const paramsMap = new Map();
                params.forEach(item => {
                  const [key, value] = item.split('=');
                  if (key) {
                    paramsMap.set(key, value);
                  }
                });
                const entries = paramsMap.entries();
                let query = '';
                const ExcludequeryArr = ['THIRD_SESSION', 'env', 'accessToken'];
                // eslint-disable-next-line no-restricted-syntax
                for (const [key, value] of entries) {
                  if (!ExcludequeryArr.includes(key)) query += `${key}=${value}&`;
                }
                url = `${domain}?${query}`;
              }
            }
            console.log('2222222222222222222222222222222', wx);

            const redirctUrl = encodeURIComponent(
              `/subPackages/webView/webView?url=${encodeURIComponent(url)}`,
            );
            const path = `/subPackages/loginPage/loginPage?isHandle=1&isWebview=1&isCancelgoBack=1&redirctUrl=${redirctUrl}`;
            wx.miniProgram.redirectTo({
              url: path,
            });
            // 23
          }
          return;
        }
        reqReceive(subParams).then(res => {
          const { code, msg } = res;
          this.$toast.clear();
          if (code === 0) {
            this.$toast({
              message: '领取成功',
              duration: 2500,
            });
            setTimeout(() => {
              wx.miniProgram.switchTab({
                url: '/pages/course/course',
              });
            }, 2600);
          } else {
            this.$toast({
              message: msg,
              duration: 2500,
            });
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.friendReceive {
  // padding-top: 100px;
  overflow: hidden;
  font-family: PingFangSC, PingFang SC, sans-serif;
  background: #f7f8fc;

  .info {
    width: 678px;
    margin: 36px auto 177px;

    .friend_phone {
      height: 40px;
      color: #333;
      font-weight: 600;
      font-size: 29px;
      line-height: 40px;

      span {
        height: 40px;
        color: #333;
        font-weight: 400;
        font-size: 25px;
        line-height: 40px;
      }
    }

    .img_box {
      width: 100%;
      margin-top: 36px;
      // overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        border-radius: 18px;
      }
    }
  }

  .botton {
    position: fixed;
    bottom: 0;
    width: 750px;
    height: 167px;
    background: #fff;
    border-radius: 22px 22px 2px 2px;
    box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);

    .bottom_btn {
      width: 678px;
      height: 80px;
      margin: 22px auto;
      color: #fff;
      font-weight: 500;
      font-size: 29px;
      line-height: 80px;
      text-align: center;
      background: #ff7f41;
      border-radius: 49px;
    }
  }
}
</style>
